import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Col, Input, Label, Row, Button, Form, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { TOURPROJECTLISTVIEW } from '../../../utils/tour'
import Icon from '../../common/js/icon'
import MapView from '../../map'
import { fetchRolesForCompanyId, fetchSearchListCount } from './../search/apiclient'
import { updateRemoveFilterToggleJA } from './../search/redux/reducer'
import { updatedSelectedSavedSearchJA, updateIsListView } from './../search/redux/searchPeristReducer'
import SearchList from './../search/searchlist'
import SearchListResult from './../search/searchListResult'
import Sort from './searchSort'
import "../search/searchPanel.scss"
import '../search/sort.scss'
import SearchSelector from './selectorDropdown'
import { preProcessorQuery } from './filters/preProcessorQuery'
import ProjectHierarchy from './hierarchyList/projectHierarchy'
import CompanyHierarchy from './hierarchyList/companyHierarchy'
import ContactHierarchy from './hierarchyList/contactHierarchy'
import { addNewSavedSearch, editSavedSearch } from '../../savedsearch/apiclient'

const SearchFormIndex = () => {
  const searchPersist = useSelector((state) => state.justAskPersist)
  const search = useSelector((state) => state.justAsk)
  const project = useSelector((state) => state.project)
  const filter = useSelector((state) => state.justAskFilter)
  const user = useSelector((state) => state.user.user);
  const savedsearch = useSelector((state) => state.savedsearch)
  const userData = useSelector((state) => state.user);
  const dispatch = useDispatch()
  const [listMapToggle, setListMapToggle] = useState(searchPersist.isListView)
  const [entityFlag, setEntityFlag] = useState(false)
  const [buttonClicked, setButtonClicked] = useState(false)
  const settings = useSelector((state) => state.settings)
  const [listName, setListName] = useState(project.isProjectSelected ? "jAskGroupedCompanyProjects" : 'jAskSearchList')
  const [isSavedSearchActive, setIsSavedSearchActive] = useState(false);
  const [saveSearchName, setSaveSearchName] = useState('');
  const [previousSavedSearchName, setPeviousSavedSearchName] = useState('');
  const [id, setId] = useState(null);
  const [modal, setModal] = useState(false);
  const [createdBy, setCreatedBy] = useState(null);
  const textSearchRef = useRef(null);


  useEffect(() => {
    // To update document title
    document.title = 'Barbour ABI'
  }, [])

  useEffect(() => {
    if (search?.listOfSelectedObjectIds?.length > 0
      || search?.fetchRolesForProjects?.roleGroups?.length > 0
      || search?.projectsForCompanyId?.length > 0 || search?.peopleProjectsList?.length > 0
      || search?.groupCompanyProjects?.length > 0) {
      setEntityFlag(true)
      setPrevNextList()
    }
  }, [search.listOfSelectedObjectIds, search.fetchRolesForProjects, search.projectsForCompanyId, search.peopleProjectsList, search.groupCompanyProjects])


  const handleListView = () => {
    setListMapToggle(!listMapToggle)
    dispatch(updateIsListView(!listMapToggle))
  }

  useEffect(() => {
    project.isProjectSelected ? setEntityFlag(true) : setEntityFlag(false)
  }, [project.isProjectSelected, search.groupCompanyProjects])

  const handleToggleChange = () => {
    setButtonClicked(true)
    dispatch(updateRemoveFilterToggleJA(!search.removeFilterToggle))
  }

  useEffect(() => {
    if (buttonClicked) {
      if (search.showCompanyHierarchy) {
        fetchRolesForCompanyId(search.objectId, search, searchPersist, dispatch)
      } else {
        var formValues = preProcessorQuery('', filter.filtersState, search?.showSelectedProjects ? "project" : searchPersist.appliedContext, search, searchPersist)
        fetchSearchListCount(formValues, dispatch, search, settings, searchPersist.query);
      }
      setButtonClicked(false)
    }
  }, [buttonClicked])

  useEffect(() => {
    if (search?.listOfSelectedObjectIds?.length > 0
      || search?.fetchRolesForProjects?.roleGroups?.length > 0
      || search?.projectsForCompanyId?.length > 0 || search?.peopleProjectsList?.length > 0
      || search?.groupCompanyProjects?.length > 0) {
      setEntityFlag(true)
    }
  }, [search.backObjectId])

  useEffect(() => {
    setPrevNextList()
  }, [search.hierarchyBack, search.showProjectHierarchy, search.showCompanyHierarchy])

  useEffect(() => {
    setListMapToggle(searchPersist.isListView)
  }, [searchPersist.isListView])

  useEffect(() => {
    if (searchPersist?.selectedSaveSearch?.saved_search_name) {
      setSaveSearchName(searchPersist?.selectedSaveSearch?.saved_search_name)
      setPeviousSavedSearchName(searchPersist?.selectedSaveSearch?.saved_search_name)
    }
    else {
      setSaveSearchName("")
      setPeviousSavedSearchName("")
    }
    if (searchPersist?.selectedSaveSearch?.saved_search_id) {
      setId(searchPersist?.selectedSaveSearch?.saved_search_id)
    }
    if (searchPersist?.selectedSaveSearch?.created_by) {
      setCreatedBy(searchPersist?.selectedSaveSearch?.created_by)
    }
  }, [searchPersist?.selectedSaveSearch])

  useEffect(() => {
    if (saveSearchName.trim().length > 0) {
      dispatch(updatedSelectedSavedSearchJA(savedsearch.detailsPage[0]))
    }
  }, [savedsearch.detailsPage])

  const setPrevNextList = () => {
    setListName(search?.listOfSelectedObjectIds?.length > 0 ? 'selectedjAskSearchList'
      : search.navigationBack === 'relationClick' && search?.fetchRolesForProjects?.roleGroups?.length > 0 ? 'projectHierarchicalSearchListJA'
        : search?.projectsForCompanyId?.length > 0 ? 'companyHierarchicalSearchListJA'
          : project.isProjectSelected ? "jAskGroupedCompanyProjects" : 'jAskSearchList')
  }

  const getSearchListResult = () => {
    return (<SearchListResult
      currentOffset={0}
      type={project.isProjectSelected ? 'project' : searchPersist.appliedContext}
      isListMapButtonFlag={listMapToggle}
      prevNextList={project.isProjectSelected ? "jAskGroupedCompanyProjects" : 'jAskSearchList'}
    />)
  }

  const toggle = () => {
    setIsSavedSearchActive(!isSavedSearchActive);

  }
  const handleSaveSearchNameChange = (event) => {
    setSaveSearchName(event.target.value);
  };
  const handleCancel = () => {
    // Handle cancel action
    setModal(false);
  };
  const handleKeyDown = (event) => {
    if (event.keyCode == 13) {
      event.preventDefault()
      let display = searchPersist.appliedContext;
      if (previousSavedSearchName === saveSearchName) {
        setModal(!modal)
      } else if (previousSavedSearchName !== saveSearchName) {
        handleSubmit(false, event)
      } else {
        handleSubmit(true, event)
      }
    }
  }

  const handleEditModal = (event) => {
    event.preventDefault()
    let display = searchPersist.appliedContext;
    if (previousSavedSearchName == saveSearchName) {
      setModal(!modal)
    } else if (previousSavedSearchName != saveSearchName) {
      handleSubmit(false, event)
    } else {
      handleSubmit(true, event)
    }
  }

  const handleSubmit = (isEdit, event) => {
    let payload = {};

    // Adding basic fields to payload
    payload['saved_search_name'] = saveSearchName.trim();
    payload['is_default'] = false;

    // Transforming conversation array with request first, then narrative
    const transformedConversation = [];
    const conversation = searchPersist?.justAskConversation || [];

    for (let i = 0; i < conversation.length; i++) {
      const userMessage = conversation[i];
      const aiMessage = conversation[i + 1];

      if (userMessage?.type === "user" && aiMessage?.type === "ai") {
        transformedConversation.push({
          request: userMessage.text,
          narrative: aiMessage.text,
        });
        i++; // Skip the next index since it's already processed
      }
    }

    // Constructing just_ask_conversation for the payload
    if (searchPersist?.savedSearchJson) {
      payload["just_ask_conversation"] = {
        request_id: searchPersist.savedSearchJson?.just_ask_conversation?.request_id, // Assign request_id
        rephrased_sentence: searchPersist.savedSearchJson?.just_ask_conversation?.rephrased_sentence, // Assign rephrased_sentence
        search_context: searchPersist.savedSearchJson?.just_ask_conversation?.search_context, // Assign search_context
        conversation: transformedConversation, // Add transformed conversation
      };
    }

    // Toggle modal
    toggle();

    if (isEdit) {
      payload['is_default'] = searchPersist?.selectedSaveSearch?.is_default;
      editSavedSearch(payload, id, dispatch, savedsearch, null, true, userData);
    } else {
      addNewSavedSearch(payload, dispatch, savedsearch, true, userData);
    }

    // Close modal
    setModal(false);
  };

  const handleCancelSaveSearch = () => {
    setIsSavedSearchActive(!isSavedSearchActive);
  }

  return (
    <div className="sidebar-mini sidebar-collapse h-100">
      <Row className='h-100'>
        <div className="main-container">
          <div className="search-list-content">
            <div className={`search-result ${searchPersist.isListView ? 'list-view-panel' : ''} `}>
              <div className="active page-title-bar">
                <div className='top-5'>
                  <div className="only-listview d-flex justify-content-between me-3">
                    <SearchSelector />
                    <div className="d-flex justify-content-end">
                      {
                        (searchPersist.appliedContext === 'company' && search.showSelectedProjects) || (searchPersist.appliedContext === 'company' && search.showCompanyHierarchy) ? (
                          <div className="switch-panel-project-tab mt-2 me-3">
                            <div className="switch-project-tab d-flex align-items-center">
                              <span className="me-2">Remove filters</span>
                              <Input id="switch-apply-filter" type="checkbox" className="cmn-toggle cmn-toggle-round"
                                checked={search.removeFilterToggle}
                                onClick={handleToggleChange}
                              />
                              <Label for="switch-apply-filter" className="mb-0"></Label>
                            </div>
                          </div>
                        ) : ''
                      }
                      <div className="maplist-container me-2">
                        <button onClick={handleListView} className={`listview outline-btn ${searchPersist.appliedContext === 'people' ? 'disabled' : ''}`} disabled={searchPersist.appliedContext === 'people'} data-intro={(searchPersist.appliedContext != "people" && !filter.isFilterActive) ? TOURPROJECTLISTVIEW.listmapview.intro : null} data-position={TOURPROJECTLISTVIEW.listmapview.position} data-class={TOURPROJECTLISTVIEW.listmapview.class}>
                          {listMapToggle ?
                            <span><Icon color="#ED1C24" size={20} icon="icon-gen-map" /> Map view </span> :
                            <span><Icon color="#ED1C24" size={20} icon="icon-gen-list" /> List view </span>}
                        </button>
                      </div>
                      <Sort />
                      <div className="over-map-panel" data-intro="Save the search to run again" data-position="bottom" data-class="cd-savesrc-info">
                        <div className="save-search-panel">
                          <div className="save-search-form">
                            <Button type="button" className="btn-primary-save outline-btn" onClick={toggle}
                            >
                              Save Conversation
                            </Button>
                            {isSavedSearchActive ?
                              <Form onKeyDown={handleKeyDown} className="visible-save-search-form save-src-form-group">
                                <div className="save-search-form-wrapper">

                                  <div className="src-name-field">
                                    <Input
                                      id="saved-search-textbox"
                                      type="text"
                                      placeholder="Enter name"
                                      onChange={handleSaveSearchNameChange}
                                      ref={textSearchRef}
                                      value={saveSearchName}
                                      maxLength="45"
                                    />
                                  </div>

                                  <div className="button-blocks">
                                    {saveSearchName.trim().length > 0 ? (
                                      id && user?.user_id === createdBy ? (
                                        <Button type="primary" className="btn-secondary-save outline-btn" onClick={handleEditModal}>
                                          Save
                                        </Button>
                                      ) : (
                                        <Button type="primary" className="btn-secondary-save outline-btn" onClick={() => handleSubmit(false)}>
                                          Save
                                        </Button>
                                      )
                                    ) : (
                                      <Button type="primary" className="btn-secondary-save outline-btn" disabled>
                                        Save
                                      </Button>
                                    )}
                                    <Button type="primary" className="btn-cancel" onClick={handleCancelSaveSearch}>
                                      Cancel
                                    </Button>
                                    <Modal isOpen={modal} >
                                      <ModalHeader> Save new conversation? <Button type="primary" className="btn-cancel" onClick={handleCancel}>Cancel</Button></ModalHeader>
                                      <ModalBody className="save-model-body">
                                        Do you want to save new conversation?
                                      </ModalBody>
                                      <ModalFooter>
                                        <Button className="outline-btn btn-save-cancel" onClick={() => handleSubmit(true)}>
                                          Replace
                                        </Button>
                                        <Button className="primary-btn btn-save-delete" onClick={handleCancel}>
                                          Cancel
                                        </Button>{' '}
                                      </ModalFooter>
                                    </Modal>
                                  </div>
                                </div>
                              </Form>
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Row className="me-0 h-100">
                <Col className='h-100 pe-0'>
                  {
                    searchPersist.isListView ?
                      entityFlag ?  // check nested and hierarchical 
                        ((search.showSelectedCompanies || search.showSelectedProjects) && search?.listOfSelectedObjectIds?.length > 0) ?
                          <SearchList entityFlag={entityFlag} prevNextList={project.isProjectSelected ? "jAskGroupedCompanyProjects" : 'selectedjAskSearchList'} /> :
                          (
                            <>
                              {(search.showProjectHierarchy && searchPersist.appliedContext === 'project') || (search.showProjectHierarchy && searchPersist.appliedContext === 'company') && search?.fetchRolesForProjects?.roleGroups?.length > 0 ?
                                <ProjectHierarchy listMapToggle={listMapToggle} type={searchPersist.appliedContext} prevNextList="projectHierarchicalSearchListJA" /> :
                                search.showCompanyHierarchy && searchPersist.appliedContext === "company" && search?.projectsForCompanyId?.length > 0 ?
                                  <CompanyHierarchy type={searchPersist.appliedContext} prevNextList="companyHierarchicalSearchListJA" /> :
                                  search.showCompanyHierarchy && search?.peopleProjectsList?.length > 0 ?
                                    <ContactHierarchy listMapToggle={listMapToggle} type={searchPersist.appliedContext} prevNextList="contactHierarchicalSearchList" />
                                    :
                                    getSearchListResult()}
                            </>
                          ) :
                        getSearchListResult() : <MapView prevNextList={listName} entityFlag={entityFlag} />
                  }
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Row>
    </div>
  )
}

export default SearchFormIndex